import { render, staticRenderFns } from "./PersonnelRecordContactCard.vue?vue&type=template&id=717e43c3"
import script from "./PersonnelRecordContactCard.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports